import { render, staticRenderFns } from "./Swap.vue?vue&type=template&id=5e2aaade&scoped=true&"
import script from "./Swap.vue?vue&type=script&lang=js&"
export * from "./Swap.vue?vue&type=script&lang=js&"
import style0 from "./Swap.vue?vue&type=style&index=0&id=5e2aaade&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2aaade",
  null
  
)

export default component.exports